$( document ).ready(function() {
  $('[data-toggle="tooltip"]').tooltip()
  $('select[data-dynamic-selectable-url][data-dynamic-selectable-target]').dynamicSelectable();
  $('select.selectize').selectpicker();

  dataConfirmModal.setDefaults({
    title: 'Confirme a ação',
    commit: 'Continuar',
    cancel: 'Cancelar'
  });

  // ADD PLACEHOLDER QUANDO HOUVER MAXLENGHT
  let inputWithLength = $('input[maxlength]');
  inputWithLength.each(function(index, element){
    if (element.placeholder === '') {
      element.placeholder = "Máximo "+ element.maxLength + " caracteres";
    }
  })

  // Disabilita campos do form
  $('form.input-disable :input').attr('disabled', true);
})
